import { useCallback, useEffect, useState } from "react";

import { CaseResponse } from "@/api/rest/models/warranty";
import { getCase } from "@/api/rest/services/warrantyService";

/** Loads one case. `failed` turns true when the case is missing or not accessible, so pages can stop loading. */
export const useCase = (caseId: number | null) => {
  const [warrantyCase, setWarrantyCase] = useState<CaseResponse | null>(null);
  const [failed, setFailed] = useState(false);

  const fetchData = useCallback(async () => {
    if (caseId === null) {
      return;
    }
    const data = await getCase(caseId);
    setWarrantyCase(data.success ? data.result : null);
    setFailed(!data.success);
  }, [caseId]);

  useEffect(() => {
    fetchData().then(null);
  }, [fetchData, caseId]);

  return [warrantyCase, fetchData, failed] as const;
};
